/**
 * Shared builder-header portability helpers for platform and agency builders.
 */

export function createWorkflowImportOpeners(setWorkflowImportMode, setWorkflowImportOpen) {
  return {
    openFileImport: () => {
      setWorkflowImportMode('file');
      setWorkflowImportOpen(true);
    },
    openUrlImport: () => {
      setWorkflowImportMode('url');
      setWorkflowImportOpen(true);
    },
  };
}

export function resolveImportedWorkflowId(workflow) {
  return workflow?.id || workflow?.workflow_id || null;
}

export function createWorkflowImportedHandler({
  setWorkflowImportOpen,
  navigate,
  getBuilderPath,
  toastSuccess,
}) {
  return (importedWorkflow) => {
    setWorkflowImportOpen(false);
    toastSuccess?.('Workflow imported as draft');
    const importedId = resolveImportedWorkflowId(importedWorkflow);
    if (importedId) {
      navigate(getBuilderPath(importedId));
    }
  };
}
